import MarketingLayout from "@/components/MarketingLayout";
import SolutionsNew from "@/pages/newsite/SolutionsNew";

export default function SolutionsHubPage() {
  return (
    <MarketingLayout>
      <SolutionsNew />
    </MarketingLayout>
  );
}
